import {madnes_fill_range} from "../framework/src/engine/madnes/madnes";

var cylinder_pos_top = 73;
export var cylinder_pos = new Array();
cylinder_pos[0] = 96;
cylinder_pos[1] = 314;
cylinder_pos[2] = 532;
cylinder_pos[3] = 750;
cylinder_pos[4] = 970;

// Animace jednotlivych symbolu + pozice ve sprite
export var icons = {
    "symbol_Devil_wink": {
        "anim": madnes_fill_range(0, 28)
    },
    "symbol_Fire_burn": {
        "anim": madnes_fill_range(1, 59)
    }
};

var fireQuestionIcon;

export var icons_tmp = new Array();

export var symbols = new Array();
symbols[0] = -1;
symbols[1] = -1;
symbols[2] = -1;
symbols[3] = -1;
symbols[4] = -1;

export var last_symbol = new Array();
last_symbol[0] = -1;
last_symbol[1] = -1;
last_symbol[2] = -1;
last_symbol[3] = -1;
last_symbol[4] = -1;

export var win_lines = {
    0: {'color': 'blue', 'line': 'line_blue', 'frame': 'winframe_blue'},
    1: {'color': 'red', 'line': 'line_red', 'frame': 'winframe_red'},
    2: {'color': 'green', 'line': 'line_green', 'frame': 'winframe_green'},
    3: {'color': 'purple', 'line': 'line_purple', 'frame': 'winframe_purple'},
    4: {'color': 'yellow', 'line': 'line_yellow', 'frame': 'winframe_yellow'}
};

function init_game(dname, config, ver)
{
    // madnes_set_texture_version(ver);
    //
    // madnes_load_init("ring_of_fire_xl", config);
    //
    // madnes_show_money_anim_scale_from = 1;
    // madnes_show_money_anim_scale_to = 1.1;
    //madnes_show_money_pos_x = wi / 2;
    // madnes_show_money_pos_y = he / 2 + 24;
    //
    // madnes_show_money_anim_callback_timeout = 40;

    // madnes_set_ico_size(214, 214 - 21);
    // madnes_set_native_sceen_size(1280, 720);

    // for (var i in to_load_audio) {
    // 	madnes_add_audio(i, to_load_audio[i]);
    // }
    //
    // for (var i in to_load) {
    // 	madnes_add_to_load(i, to_load[i]);
    // }
    //
    // for (var i in to_load_json)
    // {
    // 	if (infotexts_languages.indexOf(lang) === -1)
    // 	{
    // 		to_load_json[i] = to_load_json[i].replace("{l}", def_lang);
    // 	}
    // 	madnes_add_json(i, to_load_json[i]);
    // }
    //
    // for (var i in to_load_fonts)
    // {
    // 	madnes_add_font_to_load(i, to_load_fonts[i]);
    // }

    // madnes_set_sprite('_sprite', 214, 214);
    // madnes_set_sprite('_blur', 214, 214);
    // madnes_set_sprite('_burn', 214, 214);
    // madnes_set_sprite('_wink', 214, 214);
    //
    // madnes_set_sprite('font_menu_Big', 40, 40);
    // madnes_set_sprite('font_big-win', 134, 159);
    // madnes_set_sprite('icon_Fire_Q', 200, 200);
    // madnes_set_sprite('fire_question', 53, 70);
    // madnes_set_sprite('icon_Win', 160, 160);
    //
    // madnes_set_sprite('bwanim', 730, 400);

    // madnes_set_printdesk_function(print_desk);
    // madnes_set_updatedesk_function(print_reels);
    // madnes_set_rotate_function(rotate_run);
    //madnes_set_on_rotate_click(rotate_onclick);

    // // madnes_set_infomenu_init_function(infomenu_init);
    // madnes_set_infomenu_open_function(infomenu_open);
    // madnes_set_infomenu_close_function(infomenu_close);
    // madnes_set_infomenu_update_function(infomenu_update);
    // madnes_set_infomenu_left_function(infomenu_left);
    // madnes_set_infomenu_right_function(infomenu_right);
    // madnes_set_betmenu_open_function(betmenu_open);

    // madnes_set_coin_values_init(function (currency)
    // {
    // 	if (currency === "PLN")
    // 	{
    // 		coin_values = [0.1, 1];
    // 	} else
    // 	{
    // 		madnes_coin_values_init(currency);
    // 	}
    // });

//	madnes_set_bets_init(function(currency)
//	{
//		if(currency === "PLN")
//		{
//			bets = [10];
//		}
//	});

    // madnes_set_on_rotate_release(rotate_release);
    // madnes_set_on_forcestop_press(forcestop_press);
    //
    // madnes_init(dname);
}

// window['init_game'] = init_game;